import { Chip, Divider } from "@mui/material";
import PropTypes from "prop-types";

export default function MyDivider2({
  height = 16,
  chipText = "",
  rows = 1,
  divProps = {},
  dividerProps = {},
  noPrint = false,
  variant = "fullWidth",
}) {
  const thisDivider = (key) => (
    <div key={key} style={{ width: "100%" }}>
      {height > 1 && <div style={{ height: height / 2 }} />}
      <Divider variant={variant} {...dividerProps}>
        {chipText && <Chip label={chipText} />}
      </Divider>
      {height > 1 && <div style={{ height: height / 2 }} />}
    </div>
  );

  return (
    <div className={noPrint ? "noPrint" : ""} {...divProps}>
      {Array.from({ length: rows }, (_, i) => thisDivider(i))}
    </div>
  );
}

MyDivider2.propTypes = {
  height: PropTypes.number,
  chipText: PropTypes.string,
  rows: PropTypes.number,
  divProps: PropTypes.object,
  dividerProps: PropTypes.object,
  noPrint: PropTypes.bool,
  variant: PropTypes.oneOf(["fullWidth", "inset", "middle"]),
};

/**
 * USAGE
 *
 * <MyDivider2
 *  height={16}
 * chipText="Otsikko"
 * rows={1}
 * divProps={{ style: { marginBottom: 16 } }}
 * dividerProps={{ style: { marginBottom: 16 } }}
 * variant="fullWidth"
 * noPrint={false}
 * />
 */
